import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { rem } from "./auth-service-tools172.js";
import "react";
import { getSize, getRadius } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { polymorphicFactory } from "./auth-service-tools249.js";
import { UnstyledButton } from "./auth-service-tools258.js";
import { CloseIcon } from "./auth-service-tools279.js";
import classes from "./auth-service-tools281.js";
const defaultProps = {
  variant: "subtle"
};
const varsResolver = createVarsResolver((_, _ref) => {
  let {
    size,
    radius,
    iconSize
  } = _ref;
  return {
    root: {
      "--cb-size": getSize(size, "cb-size"),
      "--cb-radius": radius === void 0 ? void 0 : getRadius(radius),
      "--cb-icon-size": rem(iconSize)
    }
  };
});
const CloseButton = polymorphicFactory((_props, ref) => {
  const props = useProps("CloseButton", defaultProps, _props);
  const {
    iconSize,
    children,
    vars,
    radius,
    className,
    classNames,
    style,
    styles,
    unstyled,
    "data-disabled": dataDisabled,
    disabled,
    variant,
    icon,
    mod,
    ...others
  } = props;
  const getStyles = useStyles({
    name: "CloseButton",
    props,
    className,
    style,
    classes,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  return /* @__PURE__ */jsxRuntimeExports.jsxs(UnstyledButton, {
    ref,
    ...others,
    unstyled,
    variant,
    disabled,
    mod: [{
      disabled: disabled || dataDisabled
    }, mod],
    ...getStyles("root", {
      variant,
      active: !disabled && !dataDisabled
    }),
    children: [icon || /* @__PURE__ */jsxRuntimeExports.jsx(CloseIcon, {}), children]
  });
});
CloseButton.classes = classes;
CloseButton.displayName = "@mantine/core/CloseButton";
export { CloseButton };